module.exports = __webpack_public_path__ + "img/iconright.8841166c.png";